/**
 * Canonical HubHive mobile app store URLs — the single source of truth for any
 * "get the app" surface, so they can't drift apart.
 *
 * Deliberately lives outside `(marketing)`: that area is an unvetted
 * Lovable-port carryover pending its own cleanup, and the not-found page must
 * not depend on it. The marketing "Download App" CTA is a separate, dead button
 * and is intentionally not reused here.
 */
export const APP_STORE_URL =
  'https://apps.apple.com/us/app/hubhive-get-discovered/id6593692270'

// The `utm_source` the mobile share flow appends is dropped here — it carries no
// meaning on a 404 surface.
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.hubhive.mobile'
